import Cookies from "js-cookie";

export const getAccessToken = (): string | null => {
    return Cookies.get("accessToken") ?? null;
};

export const getRefreshToken = (): string | null => {
    return Cookies.get("refreshToken") ?? null;
};
